import React, { useState, Component } from "react";
import { NavLink } from "react-router-dom";

export default function EmployerMenu({ setToggleFalse }) {
  return (
    <ul>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/dashboard`}
        >
          <span className="icon icon-wysiwyg"></span>
          Dashboard
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/resumes`}
        >
          <span className="icon icon-file_present"></span> Resumes
        </NavLink>
      </li>

      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/jobslist`}
        >
          <span className="icon icon-design"></span>
          Jobs
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/postjob`}
        >
          <span className="icon icon-post"></span>
          Post Job
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/employer/messages`}
        >
          <span className="icon icon-chat_bubble_outline"></span> Messages
        </NavLink>
      </li>
      {/* #CTRL-2107 REMOVE TIPS TO GET STARTED FROM EMPLOYER MENU 
      <li
        onClick={setToggleFalse}
        style={{
          margin: '40px 15px 10px 15px',
          padding: '8px 0',
          borderLeft: '5px solid #c3e6cb',
          borderRight: '5px solid #c3e6cb',
          borderRadius: '4px',
          background: 'rgb(212 237 218 / 8%)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)'
        }}
      >
        <NavLink
          to={`${process.env.PUBLIC_URL}/employer/tips`}
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          <span>Tips To Get Started</span>
        </NavLink>
      </li> */}

    </ul>
  );
}

// export default Sidebar;
